module.exports = __webpack_public_path__ + "assets/img/dengji.f9d5b683.svg";